import { 
  call, 
  put, 
  takeEvery 
} from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* payCharges(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_PAY_CHARGES_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_PAY_CHARGES_REQUEST
    });

    yield call(Http.post, `payment`, action.payload);

    yield put({
      type: Constants.GLOBAL_PAY_CHARGES_SUCCESS
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_PAY_CHARGES_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchPayCharges() {
  yield takeEvery(Constants.GLOBAL_PAY_CHARGES_START, payCharges);
}
